import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import rcsSupplierInfoTableMapping from './RcsSupplierInfoTableMapping';
import RcsSupplierInfoTableItem from './RcsSupplierInfoTableItem';

import './RcsSupplierInfoTable.scss';

export default function RcsSupplierInfoTable (props) {
  const { supplierInfo, handleWebAddressClick, disableAATracking } = props;
  return (
    <section className='rcs-supplier-info-table'>
      {rcsSupplierInfoTableMapping
        .map((entity) => {
          const [name, getDefinition] = entity;

          return (
            <RcsSupplierInfoTableItem
              key={name}
              name={name}
              definition={getDefinition(supplierInfo, handleWebAddressClick, disableAATracking)}
            />
          );
        })
      }
    </section>
  );
}

RcsSupplierInfoTable.propTypes = {
  supplierInfo: PropTypes.instanceOf(Map),
  handleWebAddressClick: PropTypes.func,
  disableAATracking: PropTypes.bool
};
